export const ErrorMessages = {
  INVALID_DOB:
    "Sorry, we currently don't support online accounts for customers under 13. Please see or call your local Restore staff for assistance with your account creation in person",
  GENERIC: "There was a problem, please try again later.",
  ADDING_CARD: "There was a problem adding card, please try again later.",
  FAILED_SUBMITTING: "Failed to submit, please try again later.",
  APPOINTMENT_CANNOT_RESCHEDULE:
    "This appointment cannot be rescheduled at this time, please contact your studio for more information",
  TIME_TAKEN: "This time is no longer available, please select another time.",
  INCORRECT_ACCOUNT: "Incorrect account detected, please log out and try again",
  PHONE_RECOGNIZED: "Phone number recognized in our system",
};
